<template>

    <section id="about">

        <scroll-item id="si-about" data-relid="about" data-relpath="/about" @change="onChange">

            <div class="content-wrapper container flex-column flex-md-row">

                <div class="animation">
                    <animated-ninja></animated-ninja>
                </div>

                <div class="media-block d-none d-md-block">

                    <h1 v-html="about.headline">{{ about.headline }}</h1>
                    <div class="description" v-html="about.description"></div>

                </div>

                <div class="strip strip_0"></div>
                <div class="strip strip_2"></div>
                <!--div class="strip strip_3"></div-->

                <div class="gradient-wrapper d-block d-md-none"></div>
                <div class="bg-wrapper d-block d-md-none"></div>

            </div>

        </scroll-item>

        <div class="content-wrapper mobile container flex-column d-block d-md-none">

            <div class="media-block">

                <h1 v-html="about.headline">{{ about.headline }}</h1>
                <div class="description" v-html="about.description"></div>

            </div>

            <div class="strip strip_0"></div>
            <div class="strip strip_2"></div>

        </div>

        <div class="gradient-wrapper"></div>
        <div class="bg-wrapper d-none d-md-block"></div>

    </section>

</template>


<script>
    import { mapGetters } from 'vuex';
    import AOS from 'aos';
    import AnimatedNinja from "./AnimatedNinja";
    import { SplitText } from '../vendors/gsap-bonus/SplitText';
    import anime from 'animejs/lib/anime.es.js';

    let vm = {};
    let heading;
    let description;

    export default {

        name: 'About',

        components: {
            AnimatedNinja
        },

        data() {
            return {
                ninjaAnimationObj: null,
                ninjaAnimationState: true
            };
        },

        computed: {

            ...mapGetters('app', {
                about: 'ABOUT'
            })

        },

        watch: {

            ninjaAnimationState(nVal, oVal) {
                console.log('%cninjaAnimationState', 'color:dodgerblue;', nVal, oVal);

                if (nVal) {
                    this.startAnimatedNinja();
                } else {
                    this.stopAnimatedNinja();
                }
            }

        },

        created() {
            vm = this;

            vm.$eventBus.$on('ninja::ready', () => {
                console.log('ninja ready!!');
                vm.ninjaAnimationObj = window.ninjaAnimation;
                vm.setupNinjaObserver();

                if (window.ninjaAnimation && (typeof window.ninjaAnimation.bubblesStop === 'function')) {
                    window.ninjaAnimation.bubblesStop();
                    window.ninjaAnimation.ninjaStop();
                    window.ninjaAnimation.blocksStop();
                    window.ninjaAnimation.carStop();
                    window.ninjaAnimation.trexStop();
                    window.ninjaAnimation.jetStop();
                }
            });
        },

        mounted() {
            vm = this;
            AOS.refreshHard();
            vm.initWaypoint();
        },

        methods: {

            /**
             * @method updateState
             * @description
             * @param state
             */
            updateState(state) {
                this.state = state;
            },

            /**
             * @method onChange
             * @description
             * @param state
             */
            onChange(state) {
                console.log('change', state);
            },

            /**
             * @method startAnimatedNinja
             * @description Start ninja animation.
             */
            startAnimatedNinja() {
                console.log('%cstartAnimatedNinja', 'color:dodgerblue;', window.ninjaAnimation);

                if (window.ninjaAnimation && (typeof window.ninjaAnimation.bubblesStart === 'function')) {
                    window.ninjaAnimation.bubblesStart();
                    window.ninjaAnimation.ninjaStart();
                    window.ninjaAnimation.blocksStart();
                    window.ninjaAnimation.carStart();
                    window.ninjaAnimation.trexStart();
                    window.ninjaAnimation.jetStart();
                }
            },

            /**
             * @method stopAnimatedNinja
             * @description Stop ninja animation.
             */
            stopAnimatedNinja() {
                console.log('%cstopAnimatedNinja', 'color:dodgerblue;', window.ninjaAnimation);

                if (window.ninjaAnimation && (typeof window.ninjaAnimation.bubblesStop === 'function')) {
                    window.ninjaAnimation.bubblesStop();
                    window.ninjaAnimation.ninjaStop();
                    window.ninjaAnimation.blocksStop();
                    window.ninjaAnimation.carStop();
                    window.ninjaAnimation.trexStop();
                    window.ninjaAnimation.jetStop();
                }
            },

            /**
             * @method setupNinjaObserver
             * @description
             */
            setupNinjaObserver() {
                console.log('%csetupNinjaObserver=>', 'color:dodgerblue;');

                let _container = document.querySelector('section#about');

                // eslint-disable-next-line
                let _observer = new IntersectionObserver(function(entries, observer) {
                    entries.forEach(function(entry) {

                        //let _el = entry.target;
                        //console.log('_el', _el);

                        let _ninjaElVisiblePct = (Math.floor(entry.intersectionRatio * 100) + '%');
                        console.log('_ninjaElVisiblePct', _ninjaElVisiblePct, entry.intersectionRatio);

                        if (entry.intersectionRatio >= 0.6) {
                            console.log('ninja in view...playing', entry.intersectionRatio);
                            vm.ninjaAnimationState = true;
                        } else {
                            console.log('ninja out of view...pausing', entry.intersectionRatio);
                            vm.ninjaAnimationState = false;
                        }
                    });
                }, { threshold: 0.6 });

                _observer.POLL_INTERVAL = 100;

                _observer.observe(_container);
            },

            initWaypoint() {
                //window width
                let _el = document.querySelector('#hero');

                // eslint-disable-next-line
                let waypoint2 = new Waypoint({
                    element: document.getElementById('about'),
                    handler: function(direction) {
                        if (direction === "down") {
                            vm.animateContentIn();
                        } else if (direction === 'up') {
                            vm.animateContentOut();
                        }
                    },
                    offset: function() {
                        return _el.clientHeight * 0.5;
                    }
                });

            },

            animateContentIn () {
                heading = new SplitText('.highlight', { type: 'words' });
                description = new SplitText('.description', { type: 'lines' });

              anime.timeline({
                  loop: false,
              })
                .add({
                    targets: '.highlight.blue',
                    backgroundColor: 'rgba(40,188,226, 1.0)',
                    color: 'rgba(255,255,255, 1.0)',
                    duration: 750,
                    easing: 'linear',
                }, 0)
                .add({
                    targets: '.highlight.white',
                    backgroundColor: 'rgba(255,255,255, 1.0)',
                    color: 'rgba(40,188,226, 1.0)',
                    duration: 750,
                    easing: 'linear',
                }, 0)
                .add({
                    targets: heading.words,
                    duration: 1000,
                    opacity: [0,1],
                    translateY: ['1.1em', 0],
                    easing: 'spring(1, 80, 10, 0)',
                    delay: anime.stagger(50)
                }, 0)
                .add({
                    targets: description.lines,
                    duration: 1500,
                    opacity: [0, 1],
                    color: 'rgba(255,255,255, 1.0)',
                    textShadow: '0 0 3px rgba(0,0,0, 0.75)',
                    // translateY: ['1.1em', 0],
                    easing: 'spring(1, 80, 10, 0)',
                    delay: anime.stagger(100)
                }, 750).add({
                    targets: '.description',
                    color: 'rgba(255,255,255, 1.0)',
                    textShadow: '0 0 3px rgba(0,0,0, 0.75)',
                    duration: 10,
                }, 750);
            },

            animateContentOut() {
                anime.timeline({
                    loop: false,
                    begin: function() {
                        heading.revert();
                        description.revert();
                    }
                })
                .add({
                    targets: '.description',
                    duration: 100,
                    color: 'rgba(0,0,0, 0.0)',
                    textShadow: '0 0 0px rgba(0,0,0, 0)',
                    easing: 'cubicBezier(0.5, 0.05, 0.1, 0.3)'
                }, 0)
                .add({
                    targets: '.highlight.blue',
                    backgroundColor: 'rgba(0,0,0, 0.0)',
                    color: 'rgba(0,0,0, 0.0)',
                    duration: 500,
                    easing: 'cubicBezier(0.5, 0.05, 0.1, 0.3)'
                }, 0).add({
                    targets: '.highlight.white',
                    backgroundColor: 'rgba(0,0,0, 0.0)',
                    color: 'rgba(0,0,0, 0.0)',
                    duration: 500,
                    easing: 'cubicBezier(0.5, 0.05, 0.1, 0.3)'
                }, 0);
            }
        }
    }

</script>


<style lang="scss" scoped>

    //@import '../assets/styles/helpers/variables';

    section {
        background-color: $black-100;
        color: rgba(255,255,255, 1.0);
        text-align: center;
        height: auto;
        padding: 0 0 0 0;
        position: relative;
        z-index: 3;
        transition: all 0.3s $easeInOutQuad;

        @media (min-width: 576px) { // RED

        }

        @media (min-width: 768px) { // GREEN

        }

        @media (min-width: 992px) { // BLUE
            height: 800px;
            transition: all 0.3s $easeInOutQuad;
        }

        @media (min-width: 1200px) { // YELLOW

        }
    }

    .gradient-wrapper {
        background: linear-gradient(135deg, #2f6aad 0%,#3db3ce 100%);
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;

        &::after {
            content: '';
            background: linear-gradient(135deg, #2f6aad 0%,#3db3ce 100%);
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
            transform: translate3d(0, 0, 0);
            filter: blur(20px);
        }
    }

    .bg-wrapper {
        background-image: url(#{$image-path}_fpo/anim-space@1x.png);
        background-repeat: no-repeat;
        background-position: calc(50% - 250px) 50%;
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 5;
    }

    .content-wrapper {
        width: 100%;
        height: 100%;
        padding: 0 0 0 0;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        position: relative;
        top: 0;
        left: 0;
        z-index: 10;

        &.mobile {
            padding: 40px 20px 60px;

            .strip {
                width: 560px;
                height: 100%;
                position: absolute;
                top: 0;
                z-index: 6;
                transform-origin: 50% 50%;
                transform: skew(-45deg);

                &:nth-last-of-type(1) {
                    background: linear-gradient(45deg, rgba(35,121,171, 1) 0%, rgba(78,157,200, 1) 100%);
                    height: 100%;
                    left: 294px;
                    z-index: -1;
                }

                &:nth-last-of-type(2) {
                    background: linear-gradient(45deg, rgba(168,74,146, 1) 0%, rgba(168,74,146, 1) 100%);
                    height: 30px;
                    top: auto;
                    bottom: 0;
                    left: -432px;
                }
            }
        }
    }

    .animation {
        flex: 1 1 auto;
        align-self: flex-end;
        z-index: 9;
    }

    .media-block {
        text-align: left;
        max-width: 615px;
        //overflow: hidden;
        z-index: 10;

        & h1 {
            font-family: $font-coconpro-bolditalic;
            font-size: 1.125rem;
            font-weight: normal;
            line-height: 1.5;
            letter-spacing: -0.85px;
            margin: 0 0 1.250rem 0;
            transition: all 0.3s $easeInOutQuad;
            will-change: transform;

            @media (min-width: 576px) { // RED

            }

            @media (min-width: 768px) { // GREEN
                font-size: 1.125rem;
                margin: 0 0 1.500rem 0;
                transition: all 0.3s $easeInOutQuad;
            }

            @media (min-width: 992px) { // BLUE
                font-size: 2.000rem;
                margin: 0 0 2.500rem 0;
                transition: all 0.3s $easeInOutQuad;
            }

            @media (min-width: 1200px) { // YELLOW

            }
        }

        & .description {
            font-family: $font-coconpro-lightitalic;
            display: inline-block;
            color: rgba(0,0,0, 0.0);
            text-shadow: none;
            font-size: 1.0rem;
            font-weight: normal;
            line-height: 1.25;
            padding: 0 1rem;
            transition: all 0.3s $easeInOutQuad;
            will-change: transform;

            @media (min-width: 576px) { // RED

            }

            @media (min-width: 768px) { // GREEN

            }

            @media (min-width: 992px) { // BLUE
                font-size: 1.125rem;
                line-height: 1.5;
                transition: all 0.3s $easeInOutQuad;
            }

            @media (min-width: 1200px) { // YELLOW

            }
        }
    }

    .strip {
        width: 560px;
        height: 100%;
        position: absolute;
        top: 0;
        z-index: 6;
        transform-origin: 50% 50%;
        transform: skew(-45deg);

        &:nth-last-of-type(1) {
            background: linear-gradient(45deg, rgba(35,121,171, 1) 0%, rgba(78,157,200, 1) 100%);
            height: 106%;
            left: 1530px;
        }

        &:nth-last-of-type(2) {
            background: linear-gradient(45deg, rgba(185,87,159, 1) 0%, rgba(184,95,164, 1) 100%);
            height: 60px;
            top: auto;
            bottom: 0;
            left: -490px;
        }
    }

</style>

<style lang="scss">
    .highlight {
        line-height: 1;
        padding: 0rem 1rem;
        display: inline;
        box-decoration-break: clone;
        //opacity: 0;

        &.blue {
            background-color: $transparent;
            color: $transparent;
        }

        &.white {
            background-color: $transparent;
            color: $transparent;
            //margin-left: -0.5rem;
        }

        & .highlight {
            margin-right: -1rem;
        }
    }

</style>
